import structure from '../../config/siteStructureConfig.js';
import constants from '../../config/constants.js';

const $inject = ['$rootScope', '$location', 'settingsService', 'authService', 'dataService'];

const lbaNavCtrl = function ($rootScope, $location, settingsService, authService, dataService) {
  let vm = this;

  vm.settings = settingsService.settings;
  vm.navActive = true;
  vm.logout = logout;
  vm.username = authService.getUsername();
  vm.fullname = authService.getFullname();
  vm.initials = authService.getInitials();
  vm.changePath = changePath;
  vm.version = window.version;
  vm.structure = structure;
  vm.products = constants.PRODUCT_FAMILY;
  vm.activePath = $location.path().split('/')[1].replace(/-/g, ' ');

  vm.onProfileClick = onProfileClick;
  vm.showProfileMenu = false;

  function logout() {
    localStorage.removeItem('oauth');
    if (window.auth0Client) {
      window.auth0Client.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        })
    }
  }

  function changePath(path) {
    dataService.refreshDataOnLoad = true;
    $location.path(`${path}`);
  }

  function onProfileClick() {
    vm.showProfileMenu = !vm.showProfileMenu;
  }
};

lbaNavCtrl.$inject = $inject;

export default lbaNavCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaNav/lbaNavCtrl.js